import { api } from '@services';
import { Currency } from '@models';
const generateType = (actionType = 'CUSTOM', reducer = 'PAGE/ADMINSCREEN') => `${reducer}/${actionType}`;

export const getList = () => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const $list = Currency.getList(res.info.products || []);
			const trueList = $list.filter((item) => item.SYMBOL !== 'IRR' && item.ISVISIBLE === 'Y');
			const chunk = (arr, size) =>
				Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size));

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminScreen,
					$list,
					chunkedList: chunk(trueList, 2),
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminScreen,
					$list: [],
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminScreen,
					_status: status,
				},
			});
		};

		api.$product_fetch_type({ onOK, onFail, onStatus }, { type: 'C' });
	};
};
